import { useRef, useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import ReactDOM from 'react-dom/client';

import QRCode from "qrcode.react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { toPng } from "html-to-image";
import EditParticipent from "../Edit/EditParticipent";
import * as XLSX from "xlsx";
import {
  Edit,
  Trash2,
  Download,
  FileImage,
  UserCheck,
  Printer,
  FileText,
  Loader2,
} from "lucide-react";

const IdCard = ({
  card,
  index,
  fetchData,
  isLoading,
  fetchDesignations,
  elementStyles,
  eventId,
  reversedData,
  globalVisibility,
  isPreview = false,
  checkedInParticipants = {},
  handleCheckin,eventData
}) => {
  const [modal, setModal] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [isCheckingIn, setIsCheckingIn] = useState(false);
  const idCardRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);
// Add this array at the top of your component or in a config file
const CUSTOM_PRINT_EVENT_IDS = ['6835d64e09cc3f2abac99138', '69401c38f11deafe4f1bc027', '6940f91af8eed8661df60b30', '69411e53d0839fa9af7b0ef1','69412d76d0839fa9af7b10a2', '6943768dbeb82b6a6825b0a0'];

  const printRef = useRef();

  function printAsSVG(node, orientation = 'portrait') {
    const html = node.outerHTML;

    const rotationStyle = orientation === 'landscape'
      ? 'transform: rotate(-90deg); transform-origin: center center;'
      : '';

    const svg = `
    <svg xmlns="http://www.w3.org/2000/svg"
         width="100%" height="100%"
         preserveAspectRatio="none">
      <foreignObject width="100%" height="100%">
        <div xmlns="http://www.w3.org/1999/xhtml"
             style="box-sizing: border-box;
                    width:100%; height:100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;">
          <div style="${rotationStyle}">
            ${html}
          </div>
        </div>
      </foreignObject>
    </svg>
  `;

    const page = `
    <html>
      <head>
        <style>
          @page { margin: 0; size: auto; }
          html, body { margin:0; padding:0; width:100%; height:100%; overflow:hidden; }
        </style>
      </head>
      <body style="text-align: center; font-family: Arial, sans-serif;">
        ${svg}
        <script>
          window.onload = () => { window.print(); };
          window.onafterprint = () => { window.close(); };
        </script>
      </body>
    </html>
  `;

    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      return alert("Please enable pop-ups to print.");
    }
    printWindow.document.open();
    printWindow.document.write(page);
    printWindow.document.close();
  }


// Add this new function before handlePrintSVG

// Add this array at the top of your component

// Add this new function before handlePrintSVG
const handleCustomPrint = () => {
  const participantUrl =
    card && card._id
      ? `http://idcard.insideoutprojects.in/checkin/${card._id}`
      : "#";

  const ticketInfo = getTicketDisplayInfo();
  const formattedDates = ticketInfo?.dates ? formatTicketDates(ticketInfo.dates) : '';
  const fullName = `${card.firstName || ''} ${card.lastName || ''}`.trim();

  // Dynamic font size calculation based on name length
  const getNameFontSize = (name) => {
    const length = name.length;
    if (length <= 10) return '16px';      // Short names - largest
    if (length <= 15) return '14px';      // Medium names
    if (length <= 20) return '13px';      // Longer names
    if (length <= 25) return '12px';      // Very long names
    return '11px';                        // Extra long names - smallest
  };

  const getCategoryFontSize = (category) => {
    if (!category) return '11px';
    const length = category.length;
    if (length <= 10) return '12px';
    if (length <= 15) return '11px';
    return '10px';
  };

  const nameFontSize = getNameFontSize(fullName);
  const categoryFontSize = getCategoryFontSize(ticketInfo?.category);

  // Create a temporary container to render QR code
  const tempContainer = document.createElement('div');
  tempContainer.style.position = 'absolute';
  tempContainer.style.left = '-9999px';
  document.body.appendChild(tempContainer);

  const qrWrapper = document.createElement('div');
  tempContainer.appendChild(qrWrapper);

  const root = ReactDOM.createRoot(qrWrapper);
  root.render(
    <QRCode
      value={participantUrl}
      size={150}
      level="H"
      id="temp-qr-code"
    />
  );

  setTimeout(() => {
    const qrCanvas = qrWrapper.querySelector('canvas');
    
    if (!qrCanvas) {
      root.unmount();
      document.body.removeChild(tempContainer);
      alert('Failed to generate QR code');
      return;
    }

    const qrDataUrl = qrCanvas.toDataURL('image/png');
    
    // Clean up
    root.unmount();
    document.body.removeChild(tempContainer);

    // Create HTML layout HORIZONTAL (70mm x 50mm)
    // LEFT will become BOTTOM, RIGHT will become TOP after -90° rotation
    const horizontalContent = `
      <div style="
        width: 70mm;
        height: 50mm;
        background: white;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 3mm;
        box-sizing: border-box;
        font-family: Arial, sans-serif;
        gap: 3mm;
      ">
        <!-- LEFT side: Name, Category, Dates (will become BOTTOM after rotation) -->
        <div style="
          display: flex;
          flex-direction: column;
          align-items: start;
          justify-content: center;
          gap: 2mm;
          flex: 1;
        ">
          <div style="
            font-size: ${nameFontSize};
            font-weight: bold;
            color: black;
            text-align: left;
            line-height: 1.1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
          ">
            ${fullName}
          </div>
          ${ticketInfo?.category ? `
            <div style="
              font-size: ${categoryFontSize};
              font-weight: bold;
              color: black;
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 100%;
            ">
              ${ticketInfo.category}
            </div>
          ` : ''}
          ${formattedDates ? `
            <div style="
              font-size: 9px;
              font-weight: normal;
              color: black;
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 100%;
            ">
              ${formattedDates}
            </div>
          ` : ''}
        </div>

        <!-- RIGHT side: QR + "Show at the Venue" (will become TOP after rotation) -->
        <div style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 1mm;
        ">
          <div style="
            font-size: 8pt;
            font-weight: bold;
            color: black;
            text-align: center;
            white-space: nowrap;
          ">
            ${eventData?.qrCodeText || 'Show at the Venue'}
          </div>
          <img src="${qrDataUrl}" style="width: 22mm; height: 22mm; display: block;" />
        </div>
      </div>
    `;

    // Create print window with rotation (COUNTER-CLOCKWISE 90 degrees)
    const html = `
      <html>
        <head>
          <style>
            @page { 
              size: 50mm 70mm portrait;
              margin: 0;
            }
            html, body {
              margin: 0;
              padding: 0;
              width: 50mm;
              height: 70mm;
              overflow: hidden;
            }
            body {
              display: flex;
              align-items: center;
              justify-content: center;
              background: white;
            }
            .rotated-content {
              transform: rotate(-90deg);
              transform-origin: center center;
              width: 70mm;
              height: 50mm;
            }
          </style>
        </head>
        <body>
          <div class="rotated-content">
            ${horizontalContent}
          </div>
          <script>
            window.onload = () => {
              setTimeout(() => {
                window.focus();
                window.print();
              }, 250);
            };
            window.onafterprint = () => {
              window.close();
            };
          </script>
        </body>
      </html>
    `;

    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert('Please enable pop-ups to print.');
      return;
    }

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
  }, 100);
};



// Update handlePrintSVG to check for custom print events
const handlePrintSVG = (horizontal=false) => {
   if (horizontal===true) {
      printAsSVG(printRef.current);
      return;
    }
  // Check if this event should use custom print format
  if (CUSTOM_PRINT_EVENT_IDS.includes(eventId)) {
    handleCustomPrint();
  } else {
    // Default behavior
    if (printRef.current) {
      if (globalVisibility?.isLandscapePrint) {
        printAsSVG(printRef.current, 'landscape');
      } else {
        printAsSVG(printRef.current, 'portrait');
      }
    }
  }
};




  const toggleModal = () => {
    setModal(!modal);
    fetchDesignations(eventId);
  };

  const defaultElementStyles = {
    profilePicture: {
      bottom: 160,
      left: "50%",
      size: 170,
    },
    name: {
      top: 163,
      left: "50%",
      fontSize: 29,
      color: "black",
    },
    institute: {
      bottom: 293,
      left: "50%",
      fontSize: 18,
      color: "black",
    },
    designation: {
      bottom: 304,
      left: "50%",
      fontSize: 16,
      color: "black",
    },
    qrCode: {
      bottom: 215,
      left: "50%",
      size: 100,
    },
    participantId: {
      bottom: 3,
      left: "50%",
      fontSize: 12,
      color: "black",
    },
    ticketInfo: {
      bottom: 174,
      left: "50%",
      fontSize: 16,
      color: "black",
    },
    ticketDates: {
      bottom: 102,
      left: "50%",
      fontSize: 17,
      color: "black",
    },
  };
  const [styles, setStyles] = useState(defaultElementStyles);

  useEffect(() => {
    setStyles(elementStyles);
  }, [elementStyles]);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Archive ID Cards?",
      text: "This will archive the ID Cards and can be reverted later.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, archive it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            process.env.REACT_APP_API_URL + `/api/participants/archive/${id}`,
            {
              archive: true,
            }
          )
          .then((res) => {
            Swal.fire("Archived!", "ID Cards has been archived.", "success");
            fetchData();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const formatTicketRegion = (region) => {
    return region === "indian" ? "Indian" : "International";
  };

  const formatTicketDates = (dates) => {
    if (!dates || dates.length === 0) return "";

    return dates
      .map((date) =>
        new Date(date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
        })
      )
      .join(", ");
  };

  const getTicketDisplayInfo = () => {
    const ticketDetails = card.ticketDetails;
    if (!ticketDetails) return null;

    const region = card?.ticketRegion;
    const category = card?.ticketCategory;
    const selectedDates = ticketDetails.selectedDates;
    const currency = ticketDetails.currency;
    const price = ticketDetails.discountedPrice || ticketDetails.originalPrice;

    return {
      region: region ? formatTicketRegion(region) : null,
      category,
      dates: selectedDates,
      currency,
      price,
      ticketType: ticketDetails.ticketType,
    };
  };

  const ticketInfo = getTicketDisplayInfo();

  const onCheckin = async () => {
    if (isCheckingIn || checkedInParticipants[card._id]) return;

    setIsCheckingIn(true);
    try {
      await handleCheckin(card._id);
    } finally {
      setIsCheckingIn(false);
    }
  };

  const participantUrl =
    card && card._id
      ? `http://idcard.insideoutprojects.in/checkin/${card._id}`
      : "#";

  // FIXED: Added skipFonts and preferredFontFormat to resolve CORS errors
  const downloadImage = () => {
    const element = idCardRef.current;
    if (!element) return;

    setIsDownloading(true);

    toPng(element, {
      cacheBust: true,
      backgroundColor: null,
      quality: 1,
      pixelRatio: 3,
      skipFonts: true, // FIXED: Skip external font loading
      preferredFontFormat: 'woff2', // FIXED: Prefer woff2 format
    })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `id-card-${index}.png`;
        link.click();
      })
      .catch((error) => {
        console.error("Could not download the image", error);
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };

  // FIXED: Added skipFonts and preferredFontFormat
  const downloadImageWithoutBackground = () => {
    const element = idCardRef.current;
    if (!element) return;
    const originalBackgroundImage = element.querySelector("img").style.display;
    element.querySelector("img").style.display = "none";

    setIsDownloading(true);

    toPng(element, {
      cacheBust: true,
      backgroundColor: null,
      quality: 1,
      pixelRatio: 3,
      skipFonts: true, // FIXED: Skip external font loading
      preferredFontFormat: 'woff2', // FIXED: Prefer woff2 format
    })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `id-card-${index}-no-background.png`;
        link.click();
      })
      .catch((error) => {
        console.error("Could not download the image", error);
      })
      .finally(() => {
        element.querySelector("img").style.display = originalBackgroundImage;
        setIsDownloading(false);
      });
  };

  if (!card) {
    return <div>Loading...</div>;
  }

  // FIXED: Added skipFonts and preferredFontFormat
  const printIdCard = (withBackground = true) => {
    const element = idCardRef.current;
    if (!element) return;

    const backgroundImage = element.querySelector("img");
    const originalDisplay = backgroundImage
      ? backgroundImage.style.display
      : null;

    if (!withBackground && backgroundImage) {
      backgroundImage.style.display = "none";
    }

    setIsPrinting(true);

    toPng(element, {
      cacheBust: true,
      backgroundColor: null,
      quality: 1,
      pixelRatio: 3,
      skipFonts: true, // FIXED: Skip external font loading
      preferredFontFormat: 'woff2', // FIXED: Prefer woff2 format
    })
      .then((dataUrl) => {
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
          <html>
            <head>
              <title>Print ID Card</title>
              <style>
                @page {
                  margin: 0;
                  size: auto;
                }
                body {
                  margin: 0;
                  padding: 0;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100vh;
                }
                img {
                  max-width: 100%;
                  max-height: 100vh;
                  object-fit: contain;
                }
              </style>
            </head>
            <body>
              <img src="${dataUrl}" />
              <script>
                window.onload = function() {
                  setTimeout(function() {
                    window.print();
                    window.onafterprint = function() {
                      window.close();
                    };
                  }, 200);
                };
              </script>
            </body>
          </html>
        `);
        printWindow.document.close();
      })
      .catch((error) => {
        console.error("Could not print the image", error);
      })
      .finally(() => {
        setIsPrinting(false);
        if (backgroundImage) {
          backgroundImage.style.display = originalDisplay;
        }
      });
  };

  return (
    <div
      className={`relative ${
        isPreview ? "" : "mb-20"
      } border border-gray-300 rounded-lg w-[430px] `}
    >
      <div
        ref={idCardRef}
        id={`id-card-${index}`}
        className="relative rounded-[1px] h-[610px] w-[430px]"
      >
        <div className="relative z-10 h-full text-white">
          <div className="absolute inset-0">
            {card.backgroundImage && (
              <img
                src={card.backgroundImage || "/placeholder.svg"}
                alt=""
                className="w-full h-full object-cover"
              />
            )}
          </div>
          <div className="relative h-full flex flex-col justify-between p-4 items-center">
            {globalVisibility.profilePicture && card.profilePicture && (
              <div
                style={{
                  bottom: styles.profilePicture.bottom ?? undefined,
                  top: styles.profilePicture.top ?? undefined,
                  left: styles.profilePicture.left ?? undefined,
                  right: styles.profilePicture.right ?? undefined,
                }}
                className="absolute bottom-[160px] left-[50%] transform -translate-x-1/2"
              >
                <img
                  style={{
                    objectFit: "cover",
                    width: `${styles.profilePicture.size}px`,
                    height: `${styles.profilePicture.size}px`,
                  }}
                  src={card.profilePicture || "/placeholder.svg"}
                  alt="Profile"
                  className="w-[170px] h-[170px] rounded-[2px]"
                />
              </div>
            )}

            {globalVisibility.name && card.firstName && (
              <p
                style={{
                  top: styles.name.top ?? undefined,
                  bottom: styles.name.bottom ?? undefined,
                  left: styles.name.left ?? undefined,
                  right: styles.name.right ?? undefined,
                  fontSize: `${styles.name.fontSize}px`,
                  color: styles.name.color,
                  textAlign: styles.name.textAlign,
                }}
                className="absolute  w-full leading-normal whitespace-nowrap overflow-hidden text-lg transform -translate-x-1/2 font-bold  text-white mt-1 px-10 truncate"
              >
                {card.firstName} {card.lastName}
              </p>
            )}

            {globalVisibility.institute && card.institute && (
              <p
                style={{
                  top: styles.institute.top ?? undefined,
                  bottom: styles.institute.bottom ?? undefined,
                  left: styles.institute.left ?? undefined,
                  right: styles.institute.right ?? undefined,
                  fontSize: `${styles.institute.fontSize}px`,
                  color: styles.institute.color,
                  textAlign: styles.institute.textAlign,
                }}
                className="absolute bottom-[130px] w-[420px] whitespace-nowrap overflow-hidden text-lg transform -translate-x-1/2 font-semibold  text-white mt-1 px-10 truncate"
                dangerouslySetInnerHTML={{
                  __html: card.institute.toUpperCase(),
                }}
              ></p>
            )}
            {globalVisibility.designation && card.designation && (
              <p
                style={{
                  top: styles.designation.top ?? undefined,
                  bottom: styles.designation.bottom ?? undefined,
                  left: styles.designation.left ?? undefined,
                  right: styles.designation.right ?? undefined,
                  fontSize: `${styles.designation.fontSize}px`,
                  color: styles.designation.color,
                  textAlign: styles.designation.textAlign,
                }}
                className="absolute bottom-[107px]  transform -translate-x-1/2 text-md font-bold  text-black"
              >
                {card.designation}
              </p>
            )}

            {/* Ticket Information */}
            {globalVisibility.ticketInfo && ticketInfo && (
              <div
                style={{
                  top: styles?.ticketInfo?.top ?? undefined,
                  bottom: styles?.ticketInfo?.bottom ?? undefined,
                  left: styles?.ticketInfo?.left ?? undefined,
                  right: styles?.ticketInfo?.right ?? undefined,
                  textAlign: styles?.ticketInfo?.textAlign,
                }}
                className="absolute w-[420px] transform -translate-x-1/2  px-4"
              >
                <div className="space-y-2">
                  {/* Category Badge - Large and Prominent */}
                  <div
                    className="  rounded-xl px-6   inline-block font-bold tracking-wide text-black"
                    style={{
                      fontSize: `${Math.max(
                        1,
                        styles?.ticketInfo?.fontSize + 4
                      )}px`,
                    }}
                  >
                    {ticketInfo?.category}
                  </div>
                </div>
              </div>
            )}

            {/* Ticket Dates */}
            {globalVisibility.ticketDates && ticketInfo && ticketInfo.dates && (
              <div
                style={{
                  top: styles?.ticketDates?.top ?? undefined,
                  bottom: styles?.ticketDates?.bottom ?? undefined,
                  left: styles?.ticketDates?.left ?? undefined,
                  right: styles?.ticketDates?.right ?? undefined,
                  textAlign: styles?.ticketDates?.textAlign,
                }}
                className="absolute w-[420px] transform -translate-x-1/2  px-4"
              >
                <div className=" rounded-lg px-4 py-2.5 ">
                  <div
                    className="font-semibold text-black"
                    style={{
                      fontSize: `${styles?.ticketDates?.fontSize}px`,
                      color: styles?.ticketDates?.color,
                    }}
                  >
                    {formatTicketDates(ticketInfo.dates)}
                  </div>
                </div>
              </div>
            )}

     {globalVisibility.qrCode && (
  <div
    style={{
      top: styles.qrCode.top ?? undefined,
      bottom: styles.qrCode.bottom ?? undefined,
      left: styles.qrCode.left ?? undefined,
      right: styles.qrCode.right ?? undefined,
    }}
    className="absolute rounded-xl bg-white px-2 pb-3 shadow-md"
  >
    {/* Text container limited to QR width */}
    <div
      style={{ maxWidth: styles.qrCode.size }}
      className="mx-auto"
    >
      <p className="text-center text-[13px] text-black font-bold py-1 break-words">
        {eventData?.qrCodeText || "Show at the Venue"}
      </p>
    </div>

    <QRCode
      value={participantUrl}
      size={styles.qrCode.size}
      level="H"
      className="rounded-lg mx-auto"
    />
  </div>
)}

            {globalVisibility.participantId && card.participantId && (
              <div
                style={{
                  top: styles.participantId.top ?? undefined,
                  bottom: styles.participantId.bottom ?? undefined,
                  left: styles.participantId.left ?? undefined,
                  right: styles.participantId.right ?? undefined,
                  fontSize: `${styles.participantId.fontSize}px`,
                  color: styles.participantId.color,
                  textAlign: styles.participantId.textAlign,
                }}
                className="absolute bottom-[1px]  transform -translate-x-1/2 text-xs font-bold  text-black"
              >
                {card.participantId}
              </div>
            )}
            <div className="text-black font-bold bg-green-100 px-2 mt-[565px] ml-[343px]">
              {card.tag}
            </div>
          </div>
        </div>
      </div>

      <div className="">
        {/* Content to Print */}
        <div
          ref={printRef}
          className="text-center hidden border rounded-lg shadow"
        >
          <h1 style={{ fontSize: `15px` }} className="text-xl font-semibold">
            {card.firstName} {card.lastName}
          </h1>
          <p
            style={{ fontSize: `12px`, fontWeight: "500" }}
            className="text-base font-semibold"
          >
            {card.institute}
          </p>
        </div>
      </div>

      {!isPreview && (
        <div className="my-2 space-y-3">
          {/* First Row - Icon Buttons */}
          <div className="flex gap-2 justify-center">
            {/* Edit Button */}
            <button
              onClick={toggleModal}
              className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-700 text-white rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center"
            >
              <Edit className="w-4 h-4" />
            </button>

            {/* Delete Button */}
            <button
              onClick={() => handleDelete(card._id)}
              className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-700 text-white rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center"
            >
              <Trash2 className="w-4 h-4" />
            </button>

            {/* Download Button */}
            <button
              onClick={downloadImage}
              className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-700 text-white rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center"
              disabled={isDownloading}
            >
              {isDownloading ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <Download className="w-4 h-4" />
              )}
            </button>

            {/* Download Without Background Button */}
            <button
              onClick={downloadImageWithoutBackground}
              className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-700 text-white rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center"
              disabled={isDownloading}
            >
              {isDownloading ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <FileImage className="w-4 h-4" />
              )}
            </button>

             {/* Print SVG Button */}
            <button
              onClick={ ()=>handlePrintSVG(true)}
              className="px-4 py-2 bg-gradient-to-br from-blue-600 to-purple-700 text-white rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center space-x-2 font-medium text-sm whitespace-nowrap"
            >
              <span>Print defSVG</span>
              <FileText className="w-4 h-4" />
            </button>
          </div>

          {/* Second Row - Text Buttons */}
          <div className="flex gap-2 justify-center">
            {/* Check-in Button */}
            <button
              onClick={onCheckin}
              disabled={isCheckingIn || card.checkin}
              className={`px-4 py-2 rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center space-x-2 font-medium text-sm whitespace-nowrap ${
                card.checkin
                  ? "bg-gradient-to-br from-emerald-500 to-teal-700 text-white cursor-not-allowed"
                  : "bg-gradient-to-br from-indigo-500 to-fuchsia-600 text-white"
              }`}
            >
              {isCheckingIn ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  <span>Processing</span>
                </>
              ) : card.checkin ? (
                <>
                  <UserCheck className="w-4 h-4" />
                  <span>Checked In</span>
                </>
              ) : (
                <>
                  <UserCheck className="w-4 h-4" />
                  <span>Check In</span>
                </>
              )}
            </button>

            {/* Print Button */}
            <button
              onClick={() => printIdCard(true)}
              className="px-4 py-2 bg-gradient-to-br from-blue-600 to-purple-700 text-white rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center font-medium text-sm whitespace-nowrap"
            >
              <Printer className="w-4 h-4" />
            </button>

            {/* Print No Background Button */}
            <button
              onClick={() => printIdCard(false)}
              className="px-4 py-2 bg-gradient-to-br from-blue-600 to-purple-700 text-white rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center space-x-2 font-medium text-sm whitespace-nowrap"
            >
              <span>No Bg</span>
              <Printer className="w-4 h-4" />
            </button>

            {/* Print SVG Button */}
            <button
              onClick={handlePrintSVG}
              className="px-4 py-2 bg-gradient-to-br from-blue-600 to-purple-700 text-white rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center space-x-2 font-medium text-sm whitespace-nowrap"
            >
              <span>Print SVG</span>
              <FileText className="w-4 h-4" />
            </button>
          </div>

          {/* Modal */}
          {modal && (
            <EditParticipent
              fetchData={fetchData}
              eventId={eventId}
              fetchDesignations={fetchDesignations}
              toggleModal={toggleModal}
              id={card._id}
              data={card}
            />
          )}

          {/* Loading Overlay */}
          {isPrinting && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50">
              <div className="bg-white rounded-2xl p-8 shadow-2xl flex flex-col items-center space-y-4">
                <Loader2 className="w-12 h-12 text-blue-600 animate-spin" />
                <p className="text-gray-700 font-semibold">
                  Preparing print...
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default IdCard;
